import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React, { ReactNode } from "react"

interface Props {
  children: ReactNode
  focusKey?: string
  scrollFn: (y: number) => void
  ariaLabel?: string
}

export const FocusableParagraph = ({
  children,
  focusKey,
  scrollFn,
  ariaLabel,
}: Props) => {
  const { ref } = useFocusable({
    focusKey,
    onFocus: ({ top: y }, __, query) => {
      if (!(query && query.noScroll)) scrollFn(y)
    },
  })

  return (
    <Box tabIndex={0} aria-label={ariaLabel} ref={ref}>
      {children}
    </Box>
  )
}
